import React, { FC, useEffect } from 'react';
import { useConnection } from '../../connection/Application';
import { useRouter } from 'next/router';

export const LogoutPage: FC = () => {
  const connection = useConnection();
  const history = useRouter();

  useEffect(() => {
    connection.setToken(undefined);
    history.replace('/');
  });

  return <div />;
};
